import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import createDecorator from 'final-form-focus'
import arrayMutators from "final-form-arrays";

const focusOnErrors = createDecorator();

class PageWizard extends Component {
	static propTypes = {
		onSubmit: PropTypes.func.isRequired
	}
	
	static Page = ({ children }) => children

	constructor(props) {
		super(props)
		this.state = {
			page: 0,
			previousPage: [],
			waitForSubmit: false,
			values: props.initialValues || {},
			skip: false,
		}
	}

	next = values => {
		const { children } = this.props;
		const { page } = this.state;
		const { 
			seenHallucinations, 
			falseBeliefs
		} = this.props.questionOptions;
		let { previousPage } = this.state;

		// These sections refer to what's considered a new section in the spec
		switch(true) {
			case ((falseBeliefs === "no" || falseBeliefs === "I do not know") && (page === 3)): 
				this.setState({
					...this.state,
					previousPage: previousPage.concat(page),
					page: 5,
					values
				});
				break;
			case ((seenHallucinations === "no" || seenHallucinations === "I do not know") && (page === 1)):
				this.setState({
					...this.state,
					previousPage: previousPage.concat(page),
					page: 3,
					values
				});
				break;
			default:
				// Standard next page
				this.setState({
					...this.state,
					previousPage: previousPage.concat(page),
					page: Math.min(page + 1, children.length - 1),
					values
				});
		}
	}

  	previous = () => {
		let { previousPage } = this.state;
		let page = previousPage.slice(-1)[0];
		// Remove the item we're about to use
		previousPage.pop();
		this.setState({
			...this.state,
			page: page,
			previousPage: previousPage
		});

	};

	handleSubmit = values => {
		const { onSubmit, noOfPages } = this.props;
		const { page } = this.state;
		const isLastPage = page === noOfPages;
		if (isLastPage) {
			return onSubmit(values);
		}
		else {
			this.next(values);
		}
		// this.props.toTop.current.scrollIntoView({ behavior: "smooth" });
	}

	skipToPdf = values => {
		const { onSubmit, noOfPages } = this.props;
		const { page } = this.state;
		const isLastPage = page === noOfPages;
		if (isLastPage) {
			this.setState({
				...this.state,
				skip: true
			})
			return onSubmit(values);
		} else {
			this.next(values);
		}
	}

	resetForm = (form) => {
		this.setState(this.baseState);
		this.props.questionReset();
		this.props.submit(false);
        return form.reset;
    }

	render() {
		const { children, noOfPages, submitted } = this.props;
		const { emailAddress, agreeToTerms, firstName, lastName } = this.props.questionOptions;
		const { page, values, skip } = this.state;
		// Deduces which page we are currently using
		const activePage = React.Children.toArray(children)[page];
		// noOfPages passed from main form component
		const isFirstPage = page === 0;
		const isLastPage = page === noOfPages;
		// Build our lentils
		let pageLoop = 0;
		let lentils = [];

		while(pageLoop <= noOfPages) {
			pageLoop++;
			lentils.push(<li key={pageLoop} className={(pageLoop <= (page + 1) ? "current" : "")}><span /></li>);
		}

		return (
			<Form
				initialValues={values}
				onSubmit={this.handleSubmit}
				decorators={[ focusOnErrors ]}
				mutators={{
					...arrayMutators
				}}
			>
				{({ form, handleSubmit, submitting, values }) => (
					<form onSubmit={handleSubmit}>
						<div className="row" style={{position: "relative"}}>
							{page > 0 && !isLastPage && (
								<button className="btn text-center previous" type="button" onClick={() => this.previous()}>
									<svg width="50" height="50" viewBox="0 0 20 20" className="bi bi-chevron-left" style={{fill: "#ee9f5c"}} xmlns="http://www.w3.org/2000/svg">
										<path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
									</svg>
								</button>
							)}
							<div className="discussion-guide">
								<div className="form-container">
									{submitted && !skip && (
										<div className="offer-signup">
											<div className="col-lg-6 offset-lg-3">
												<h1 className="h1" style={{marginTop:"1em"}}>Thank you for signing up</h1>
												<p>Please check your inbox for a copy of your completed guide. From time to time, we'll also send you important information about these symptoms and NUPLAZID.</p>
											</div>
										</div>
									)}

									{submitted && skip && (
										<div className="offer-signup">
											<div className="col-lg-6 offset-lg-3">
												<h1 className="h1" style={{marginTop:"1em"}}>Thank you</h1>
												<p>Please check your Downloads folder for your completed discussion guide.</p>
											</div>
										</div>
									)}
									{!submitted && (
										activePage
									)}
									{isLastPage && !submitted && (
										<div className="row mx-lg-4">
											<div className="col-sm-6">
												<button 
													className="btn btn-primary btn-lg w-100 text-center wide-mobile signup-btn"
													style={{width: "90%", padding: "15px"}}
													type="submit"
													disabled={submitting}
												>
													<b>Sign up and email my discussion&nbsp;guide</b>
												</button>
											</div>
											<div className="col-sm-6">
												<button
													className="btn btn-lg w-100 text-center text-center wide-mobile skip float-left"
													type="submit"
													style={{width: "90%", padding: "15px"}}
													disabled={submitting}
												>
                                                    <b>Skip and download my discussion&nbsp;guide</b>
												</button>
											</div>
										</div>
									)}
								</div>
							</div>
							{!isLastPage && !isFirstPage && (
								<button className="btn text-center next" type="submit" onClick={() => this.next}>
									<svg className="bi bi-chevron-right" width="50" height="50" viewBox="0 0 20 20" style={{fill: "#ee9f5c"}} xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M6.646 3.646a.5.5 0 01.708 0l6 6a.5.5 0 010 .708l-6 6a.5.5 0 01-.708-.708L12.293 10 6.646 4.354a.5.5 0 010-.708z"/></svg>
								</button>
							)}
						</div>
						<ul className="dotstyle dotstyle-scaleup">
							{!submitted && lentils}
						</ul>
						{process.env.NODE_ENV === "development" && (
							<pre style={{marginTop: "100px", marginBottom: "50px"}}>{JSON.stringify(values, 0, 2)}</pre>
						)}
					</form>
				)}
			</Form>
		)
	}
}

const mapStateToProps = (state) => {
	const { questionOptions } = state;
	return { questionOptions: questionOptions };
}


export default connect(mapStateToProps, actions)(PageWizard);
